// @flow strict
import * as api from "@kiwicom/nitro/lib/services/auth/api"

import { cuckooEvents } from "../../consts/enums"
import cuckoo from "../cuckoo/cuckoo"

type MMBRedirectInput = {|
  bid: string,
  email: string,
  iata: string,
  departure: Date,
|}

function mmbRedirect(
  lang: string,
  { bid, email, iata, departure }: MMBRedirectInput,
): Promise<void> {
  return api.getMyBookingToken({ bid, email, iata, departure }).then(token => {
    cuckoo.track(cuckooEvents.AUTH_LOGIN_WITH_BOOKING_GETTING_TOKEN_SUCCESS, { token })
    cuckoo.infinario("userOneTimeLogin", { action: "submit" })
    cuckoo.infinario("identify", email)

    window.location = `/${lang}/manage/${bid}/${token}`
  })
}

export default mmbRedirect
